import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import './Styles/App.css';
import Home from './Home';
import Blog from './Blog';
import BlogPage from './Blogs/BlogPage';
import NotFound from './NotFound';

import emailImg from './Images/email-plus-outline.png';
import linkedinImg from './Images/linkedin.png';
import mediumImg from './Images/medium.png'
import instagramImg from './Images/instagram.png'

function App() {
  return (
    <Router>
      <header>
        <Link to='/'><img src="/images/L2w.png" alt="Oleg Orlenko" title="Oleg Orlenko"/></Link>
        <Link to='/blog' className='blog-link'>Blog</Link>
      </header>
      <main className='App'>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />}>
            <Route path=":slug" element={<BlogPage />} />
          </Route>
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <footer>
        <a href="mailto:info@olegorlenko.com"><img alt="email" src={emailImg} /></a>
        <a href="https://medium.olegorlenko.com/"><img alt="medium" src={mediumImg} /></a>
        <a href="https://www.linkedin.com/in/olegorlenko/"><img alt="linkedin" src={linkedinImg} /></a>
        <a href="https://instagram.com/charly_b13"><img alt="instagram" src={instagramImg} /></a>
      </footer>
    </Router>
  );
}

export default App;
